import Component from './component';
import Marquee from './marquee';
import { metadataTitle, metadataGrouping, metadataIcon } from '../utils/metadata';

export default class Metadata extends Component {
  constructor (props) {
    super(props);
    this.$coverart = null;
    this.$title = null;
    this.$subtitle = null;
    this.$marquee = null;
    this.shouldAnimateMarquee = false;
    this.marquee = new Marquee({
      started: false,
      pauseOnHover: true
    });
    this.locale = this.props.player.locale;
    this.handleEvent = this.handleEvent.bind(this);
  }

  getDefaultProps () {
    return {};
  }

  update () {
    if (this.$coverart) {
      const iconUrl = metadataIcon(this.props.player, 'medium');

      if (iconUrl) {
        this.$coverart.removeAttribute('hidden');
        this.$coverart.style.backgroundImage = `url('${iconUrl}')`;
      } else {
        this.$coverart.setAttribute('hidden', true);
        this.$coverart.style.backgroundImage = '';
      }
    }

    this.$title.textContent = metadataTitle(this.props.player);
    this.$subtitle.textContent = metadataGrouping(this.props.player, {
      includeDate: true,
      dateFormat: this.props.dateTimeFormat,
      locale: this.locale
    });

    const marqueeDims = this.marquee.$element.getBoundingClientRect();
    const marqueeContentDims = this.marquee.$content.getBoundingClientRect();

    this.shouldAnimateMarquee = (marqueeContentDims.width > marqueeDims.width);
  }

  /**
   * Handle player events
   *
   * @param {Object} event
   */
  handleEvent (event) {
    if (event.type === 'nowplayingchange') {
      event.preventDefault();
      this.update();
    }

    if (event.type === 'playlistselect') {
      event.preventDefault();
      this.update();
    }

    if (event.type === 'playlistchange') {
      this.update();
    }

    if (event.type === 'state' && event.currentState === 'playing' && this.shouldAnimateMarquee) {
      this.marquee.start();
    } else {
      this.marquee.stop();
    }
  }

  attach (element) {
    super.attach(element);
    this.$coverart = this.$('.iono-coverart');
    this.$coverartImage = this.$('.iono-coverart__image');
    this.$title = this.$('.iono-player-metadata-title');
    this.$subtitle = this.$('.iono-player-metadata-subtitle');
    this.$marquee = this.$('.iono-marquee');
    this.marquee.attach(this.$marquee);
    this.props.player.on('nowplayingchange', this.handleEvent);
    this.props.player.on('playlistselect', this.handleEvent);
    this.props.player.on('playlistchange', this.handleEvent);
    this.props.player.on('state', this.handleEvent);
  }

  detach () {
    super.detach();
    this.$coverart = null;
    this.$coverartImage = null;
    this.$title = null;
    this.$subtitle = null;
    this.$marquee = null;
    this.marquee.detach();
    this.props.player.off('nowplayingchange', this.handleEvent);
    this.props.player.off('playlistselect', this.handleEvent);
    this.props.player.off('playlistchange', this.handleEvent);
    this.props.player.off('state', this.handleEvent);
  }
}
